<div class="tabs-container">
  <div class="tabs-container__header disk-top-display">
    <div class="tabs-container__header-title">
      <h2>{{ "Tickets.MyTickets" | translate }}</h2>
    </div>
  </div>
  <!-- -----mobileView -->
  <div class="tabs-container__mobile-header mobile-display">
    <div class="tabs-container__header-title">
      <div>{{ "Tickets.MyTickets" | translate }}</div>
    </div>
  </div>

  <div class="error-success">
    <app-error-handling
      *ngIf="errorMessage && !successMessage"
      [message]="errorMessage"
    ></app-error-handling>
    <app-success-handling
      *ngIf="!errorMessage && successMessage"
      (closeEvent)="successMessage=''"
      [message]="successMessage"
    ></app-success-handling>
  </div>

  <ul class="tab-group">
    <li
      *ngFor="let tab of tabs; index as i"
      class="tab"
      [class.active]="tab.active"
      (click)="changeTab(i)"
    >
      {{ tab.title | translate }}
    </li>
  </ul>

  <div class="tab-content-group">
    <ng-container *ngFor="let tab of tabs">
      <div class="tab-content" *ngIf="tab.active">
        <app-my-tickets
          (ticketsData)="getTicketsData($event)"
          (emitSuccessMessage)="handleSuccessMessage($event)"
          (emitErrorMessage)="handleErrorMessage($event)"
          [myTicketsStatus]="MyTicketsStatusEnum.UpComingTickets"
          [reload]="reload"
          *ngIf="tab.title ==  'Tabs.' +  MyTicketsStatusEnum.UpComingTickets"
        ></app-my-tickets>

        <app-my-tickets
          (ticketsData)="getTicketsData($event)"
          (emitSuccessMessage)="handleSuccessMessage($event)"
          (emitErrorMessage)="handleErrorMessage($event)"
          [myTicketsStatus]="MyTicketsStatusEnum.PastTickets"
          [reload]="reload"
          *ngIf="tab.title ==  'Tabs.' + MyTicketsStatusEnum.PastTickets"
        ></app-my-tickets>
      </div>
    </ng-container>
  </div>
</div>
